/**
 * 信息流请求模块
 */

import df from './news/df'
const MILLISECONDS_IN_A_SECOND = 1000
const ONE_MINUTE = 60
const ONE_HOUR = 3600
const ONE_DAY = 86400
export default {
  /**
   * 信息流请求分发
   * @param newsType
   * @param params
   * @param callback
   */
  getList(newsType, params, callback) {
    let fnName = params.fnName, report = params.report;
    let dhUrl = '';
    delete (params.fnName);
    delete (params.report);
    switch (newsType) {
      case 'df':
        df[fnName](params, (err, res) => {
          if (err) {
            callback(err);
          } else {
            this.formatDfData(res, callback, fnName, report);
          }
        });
        break;
      case 'df_2345':
        if (params.pgnum <= 22) {
          dhUrl = '//newsie.2345.com/api/navigate/getXxlData.php?type=xxlLeft&page=' + params.pgnum;
          fetch(dhUrl).then(res => res.json()).then(data => {
            this.formatDfDataLeft(data, callback, fnName, report);
          }).catch(callback);
        }
        break;
      case 'df_2345_right':
        dhUrl = '//newsie.2345.com/api/navigate/getXxlData.php?type=xxlRight';
        fetch(dhUrl).then(res => res.json()).then(data => {
          this.formatDfDataRight(data, callback, fnName, report);
        }).catch(callback);
        break;
      default:
        console.log('news type err', ...arguments);
        break;
    }
  },
  /**
   * 东方数据格式化
   * @param res
   * @param callback
   * @param fnName
   * @param reported
   */
  formatDfData (res, callback, fnName, reported) {
    const maxShowImgs = 4;
    if (!!res['data']) {
      res['data'].forEach((newsInfo, index) => {
        res['data'][index].provider = 'df';
        res['data'][index].isAd = false;
        res['data'][index].show = true;
        res['data'][index].newsId = `df_${newsInfo.uniquekey}_${newsInfo.rowkey}`;
        if (newsInfo['miniimg02_size'] > 0) {
          res['data'][index].miniimg_size = newsInfo['miniimg02_size'];
          res['data'][index].miniimg = newsInfo['miniimg02'];
        }
        if (res['data'][index].miniimg_size < 3 && res['data'][index].miniimg_size >= 1) {
          res['data'][index].miniimg = res['data'][index].miniimg.slice(0, 1);
          res['data'][index].miniimg_size = 1;
        }
        if (res['data'][index].miniimg_size > maxShowImgs) {
          res['data'][index].miniimg = res['data'][index].miniimg.slice(0, 4);
          res['data'][index].miniimg_size = 4;
				}
        for(let imgIdx in res['data'][index].miniimg) {
          res['data'][index].miniimg[imgIdx]['src'] = this.formatUrlProtcl(res['data'][index].miniimg[imgIdx]['src']);
        }
        res['data'][index]['url'] = this.formatUrlProtcl(res['data'][index]['url']);
        res['data'][index].showMorePos = (res['data'][index].miniimg_size === maxShowImgs - 1);
        if (fnName === 'getEntList') {
          res['data'][index].itemType = 'singlepic';
        } else {
          res['data'][index].itemType = (res['data'][index].miniimg_size < 3 && res['data'][index].miniimg_size >= 1 ? 'singlepic' : 'multipic');
          res['data'][index].newsClass = 'news-pack';
          // res['data'][index].timeStr = this.formatDfDate(newsInfo.date, res['ts']);
          res['data'][index].timeStr = this.getTimeStr(res['data'][index].pushdate, res['ctime']);
        }
        res['data'][index].click_report_50bang = (reported['click_report'] || 'click_reported');
      });
      callback(null, res);
    } else {
      callback({'msg': 'response data fields "data" err'});
    }
  },
  /**
   * 导航数据格式化
   * @param res
   * @param callback
   * @param fnName
   * @param reported
   */
  formatDfDataLeft (data, callback, fnName, reported) {
    const maxShowImgs = 4;
    if (!!data) {
      let res = {
        endkey: '',
        newkey: '',
        ts: 1568794411,
        data: data.map(item => {
          item.provider = 'df';
          item.isAd = false;
          item.show = true;
          item.newsId = `df_${item.itemId}`;
          if (item.miniimg_size > 0) {
            item.miniimg_size = item.miniimg_size;
            item.miniimg = item.miniimg;
          }
          if (item.miniimg_size < 3 && item.miniimg_size >= 1) {
            item.miniimg = item.miniimg.slice(0, 1);
            item.miniimg_size = 1;
          }
          if (item.miniimg_size > maxShowImgs) {
            item.miniimg = item.miniimg.slice(0, 4);
            item.miniimg_size = 4;
          }
          for(let imgIdx in item.miniimg) {
            item.miniimg[imgIdx]['src'] = this.formatUrlProtcl(item.miniimg[imgIdx]['src']);
          }
          item.url = this.formatUrlProtcl(item.url);
          item.showMorePos = (item.miniimg_size === maxShowImgs - 1);
          if (fnName === 'getEntList') {
            item.itemType = 'singlepic';
          } else {
            item.itemType = (item.miniimg_size < 3 && item.miniimg_size >= 1 ? 'singlepic' : 'multipic');
            item.newsClass = 'news-pack' + (item.miniimg_size < 3 && item.miniimg_size >= 1 ? '' : '  news-pics');
            item.timeStr = '';
          }
          item.click_report_50bang = (reported['click_report'] || 'click_reported');
          return item;
        })
      };
      callback(null, res);
    } else {
      callback({'msg': 'response data fields "data" err'});
    }
  },
  /**
   * 导航数据格式化
   * @param res
   * @param callback
   * @param fnName
   * @param reported
   */
  formatDfDataRight (data, callback, fnName, reported) {
    const maxShowImgs = 4;
    if (!!data) {
      let res = {
        endkey: '',
        newkey: '',
        ts: 1568794411,
        data: data.map(item => {
          item.provider = 'df';
          item.isAd = false;
          item.show = true;
          item.newsId = `df_${item.itemId}`;
          item.topic = item.title;
          item.url = item.url;
          item.miniimg = [{'src':item.pic169}];
          item.click_report_50bang = (reported['click_report'] || 'click_reported');
          return item;
        })
      };
      callback(null, res);
    } else {
      callback({'msg': 'response data fields "data" err'});
    }
  },
  /**
   * Url协议优化
   * @param url
   */
  formatUrlProtcl(url) {
    return url.replace(/^http(s)?\:\/\//, '//');
  },
  /**
   * 东方信息流日期格式化
   * @param newsDate
   * @param serverDate
   * @returns {string}
   */
  formatDfDate(newsDate, serverDate) {
    let timeStr = '';
    let newsTime = new Date(1000 * newsDate)
    let timeDiff = serverDate - newsDate
    let todayZero = Date.parse(new Date((new Date(1000 * serverDate)).toJSON().substr(0, 10) + ' 00:00')) / 1000
    // 今天凌晨00:00时间戳
    let todayZeroTimeDiff = newsDate - todayZero; // 新闻时间和今天凌晨00:00的时间差
    if (timeDiff < 3600) {
      let minite = Math.ceil(timeDiff / 60) > 0 ? Math.ceil(timeDiff / 60) : Math.ceil(Math.random() * 10)
      timeStr = minite > 59 ? '59分钟前' : minite + '分钟前'
    } else if (todayZeroTimeDiff > 0 && todayZeroTimeDiff <= 86400) {
      timeStr = Math.floor(timeDiff / 3600) + '小时前'
    } else if (todayZeroTimeDiff <= 0 && todayZeroTimeDiff > -86400) {
      timeStr = '昨天 ' + (newsTime.getHours() < 10 ? '0' + newsTime.getHours() : newsTime.getHours()) + ':' + (newsTime.getMinutes() < 10 ? '0' + newsTime.getMinutes() : newsTime.getMinutes())
    } else if (todayZeroTimeDiff <= -86400) {
      timeStr = newsTime.getFullYear() +
        '-' + (newsTime.getMonth() < 9 ? '0' + (newsTime.getMonth() + 1) : newsTime.getMonth() + 1) +
        '-' + (newsTime.getDate() < 10 ? '0' + newsTime.getDate() : newsTime.getDate()) +
        ' ' + (newsTime.getHours() < 10 ? '0' + newsTime.getHours() : newsTime.getHours()) +
        ':' + (newsTime.getMinutes() < 10 ? '0' + newsTime.getMinutes() : newsTime.getMinutes())
    }
    return timeStr;
	},

	getTimeStr(timeStamp, now) {
		const time = ((new Date(now) || Date.now()) - new Date(timeStamp).getTime()) / MILLISECONDS_IN_A_SECOND
		if (time >= ONE_DAY) {
			return `${Math.floor(time / ONE_DAY)}天前`
		} else if (time >= ONE_HOUR) {
			return `${Math.floor(time / ONE_HOUR)}小时前`
		} else if (time >= ONE_MINUTE) {
			return `${Math.floor(time / ONE_MINUTE)}分钟前`
		} else {
			return '刚刚'
		}
	},
}
